import React from 'react';
import { getImageSrc } from '../../../util';
import { FullBackground } from '../../../components/FullBackground';

type Props = {
  className?: string;
};

const FSRSuccessStory: React.FC<Props> = ({ className }) => {
  return (
    <>
      <FullBackground
        color={'bg-cassava_color -mt-20 -mb-20'}
        shadow={false}
        isSlanted={false}
      >
        <div
          className={`relative  py-16 lg:py-24 xl:py-32 2xl:py-32  ${className}`}
          style={{ marginRight: '50vw', marginLeft: '50vw' }}
        >
          <div
            className={`relative bg-white rounded-xl shadow-lg w-full  `}
            id={'UseCase_Success_Story_Container'}
          >
            <div
              className={'bg-gray-50 md:px-10 md:py-10 rounded-t-xl px-8 py-6 '}
              id={'UseCase_Success_Story_Header'}
            >
              <div className={'flex-col space-y-4 md:max-w-3/5'}>
                <div className={'flex items-center'}>
                  <div className="flex-shrink-0">
                    <picture>
                      <source
                        srcSet={getImageSrc('Cassava.webp')}
                        type={'image/webp'}
                      />
                      <source
                        srcSet={getImageSrc('Cassava.png')}
                        type={'image/png'}
                      />
                      <img
                        className="lazyload mx-auto h-20 w-20 lg:w-22 lg:h-22 rounded-full"
                        data-src={getImageSrc('Cassava.webp')}
                        alt={'company logo'}
                      />
                    </picture>
                  </div>
                  <div className={'text-center '}>
                    <span
                      className={`ml-4 inline-flex font-semibold items-center px-3 py-1 rounded-full text-md bg-cassava_color text-gray-100 `}
                    >
                      Case Study
                    </span>
                  </div>
                </div>
                <p className="text-lg text-gray-600 sm:text-lg">
                  As Cassava planned to reopen outdoor dining, they needed a way
                  to keep everyone safe while running a sustainable operation.
                </p>
              </div>
            </div>
            <div
              className={'bg-white px-8 py-6 md:px-8 md:py-6 rounded-b-xl'}
              id={'UseCase_Success_Story_Boyd'}
            >
              <div
                className={
                  'flex-col lg:grid lg:grid-cols-5 lg:gap-6 lg:items-center'
                }
              >
                <div className={'lg:col-span-3'}>
                  <div className="text-left mt-3 mb-8">
                    <p className="text-base text-cassava_color font-semibold tracking-wide uppercase">
                      Solution
                    </p>

                    <p className="text-lg leading-normal text-gray-500 mt-3">
                      Instead of risking the health of their staff and guests or
                      giving up on table service entirely, Cassava quickly
                      reinvented their dine-in operation through TableTab.
                    </p>
                  </div>
                  <div className="text-left mt-3 mb-8">
                    <p className="text-base text-cassava_color font-semibold tracking-wide uppercase">
                      Impact
                    </p>

                    <p className="text-lg leading-normal text-gray-500 mt-3">
                      TableTab helped Cassava stay safe while serving others,
                      eliminate the need to take payment so servers could spend
                      more time with guests, and keep tables turning with
                      specified time constraints. They also capture incremental
                      spend through instant ordering without a single lost
                      payment or walkout.
                    </p>
                  </div>
                  <div className="text-left mt-3 mb-3">
                    <p className="text-base text-cassava_color font-semibold tracking-wide uppercase">
                      Bouncing Back
                    </p>

                    <p className="text-lg leading-normal text-gray-500 mt-3">
                      Within a month using TableTab, Cassava's 7-table outdoor
                      terrace accounted for 50% of the restaurant's business.
                    </p>
                  </div>
                </div>
                <div className={'lg:col-span-2'}>
                  <div
                    className={
                      'bg-white shadow-2xl rounded-lg 2xl:-mt-60 xl:-mt-56 lg:-mt-48 mt-10 2xl:w-3/4 items-center 2xl:mx-auto'
                    }
                  >
                    <blockquote className="lg:px-8 lg:py-10 px-6 py-6 xl:py-14 xl:px-10">
                      <div className="max-w-3xl mx-auto text-left text-base md:text-lg  text-gray-800">
                        <p>
                          &ldquo;If you are in search of a contactless payment
                          with digital menu system, we highly recommend
                          TableTab. Not having to run back and forth with
                          receipts and credit cards has been safer for sure and
                          it cuts turn time drastically!&rdquo;
                        </p>
                      </div>
                      <footer className="mt-8">
                        <div className="md:flex md:items-center md:justify-center">
                          <div className="mt-3 text-center md:mt-0 md:flex md:items-center">
                            <div className="text-base font-medium text-cassava_color">
                              Yuka Ioroi
                            </div>

                            <svg
                              className="hidden md:block mx-1 h-5 w-5 text-black"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M11 0h3L9 20H6l5-20z" />
                            </svg>

                            <div className="text-base font-medium text-gray-500">
                              Co-Owner at Cassava
                            </div>
                          </div>
                        </div>
                      </footer>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default FSRSuccessStory;
